const showNavbar = () => {
  document.getElementById('navbar').style.top = '0';
  document.getElementById('navbar').style.opacity = '1';
  document.getElementById('navbar').style.webkitTransition = '0.3s';
  document.getElementById('navbar').style.transition = '0.3s';
  document.getElementById('navbar').style.transitionDelay = '0.3s';
};

const hideNavbar = () => {
  document.getElementById('navbar').style.top = '-50px';
  document.getElementById('navbar').style.opacity = '0';
  document.getElementById('navbar').style.webkitTransition = '0.3s';
  document.getElementById('navbar').style.transition = '2';
  document.getElementById('navbar').style.transitionDelay = '1s';
};

const StickyTopBar = () => {
  let prevScrollPos = window.pageYOffset;
  window.onscroll = function pageScroll() {
    const isTop = window.scrollY === 0;
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > prevScrollPos && !isTop) {
      hideNavbar();
    } else {
      showNavbar();
    }
    prevScrollPos = currentScrollPos;
  };
};

export default StickyTopBar;
